module.exports = __webpack_public_path__ + "media/images/admin/icons/cloud-off-a686de179fa512ec708a6427e1e8b880.svg";